import { OrganizationSwitcher, UserButton } from '@clerk/react';

/** Clerk org switcher + account menu for the dashboard shell (B2B). */
const ClerkOrganizationToolbar = () => (
  <div className="flex shrink-0 items-center gap-3">
    <OrganizationSwitcher
      hidePersonal
      afterCreateOrganizationUrl="/dashboard"
      afterSelectOrganizationUrl="/dashboard"
      appearance={{
        elements: {
          rootBox: 'flex items-center',
          organizationSwitcherTrigger:
            'rounded-lg border border-custom-lightSilver/90 bg-white/95 px-3 py-2 shadow-[0_1px_2px_rgba(1,3,11,0.04)]',
        },
      }}
    />
    <UserButton
      afterSignOutUrl="/sign-in"
      appearance={{
        elements: {
          avatarBox: 'h-9 w-9',
        },
      }}
    />
  </div>
);

export default ClerkOrganizationToolbar;
